<template>
  <section class="reply-refer">
    <h2>{{title}}</h2>
    <div
      v-if="!showBuyable"
      class="abs-top-right">
      <v-button
        gray
        @click="handleCancel">Back</v-button>
      <template v-if="editType === 1 || editType == 3">
        <v-button
          v-show="editType != 3"
          gray
          @click="onSaveDraft">Save Draft</v-button>
        <v-button
          green
          @click="clickNext(1)">Next</v-button>
      </template>
      <v-button
        v-else
        green
        :disabled="BuyableDisabled"
        @click="onReferralSendSms(2)">Complete Buyable Quote(s)</v-button>
    </div>
    <div
      v-else
      class="abs-top-right">
      <v-button
        gray
        @click="handleCancel">Back</v-button>
    </div>
    <div class="flex">
      <div class="main-left">
        <ul>
          <li
            v-for="(item, index) in quoteList"
            :key="index"
            class="flex flex-sb"
            :class="{ 'active': index === activeQuote }"
            @click="changeActiveQuote(index)">
            <span
              class="flex"
              :class="{'del_line':!item.quote_status && editType==3}">
              <template v-if="editType == 2">
                <!--                <v-checkbox v-model="item.is_buyable_choose" />-->
                <span
                  v-if="item.customer_chose === 1"
                  class="star"></span>
              </template>
              <!-- {{ item.plan || item.title }} -->
              <template v-if="isSME">{{quote_name}}</template>
              <template v-else>
                {{getLocalAllOptionName('insurer', item.company_id)}}
                {{ item.company_id? ' - ' : ''}}
                {{getOptionName('classOptions', item.class_id)}}
                {{item.trm_of_cvr || item.plan_id? ' - ' : ''}}
                <!-- 车险用的是trm_of_cvr，其他保险是plan_id -->
                <!-- 绑定的是id值，刚好下标是id-1 -->
                {{getCurrentPlanName(index,item.plan_id)}}
              </template>
            </span>
            <span v-if="editType !== 2&&quoteList.length>1 && (editType == 3 && index != 0)">
              <font-awesome-icon
                icon="trash-alt"
                @click="handleDeleteQuote(item,index)"></font-awesome-icon>
            </span>
          </li>
        </ul>
        <!--        <v-button-->
        <!--          v-if="!isSME"-->
        <!--          gray-->
        <!--          :disabled="isRenew"-->
        <!--          @click="handlerAddQuote">Add Another Quote</v-button>-->
        <div
          v-if="!!ticket_id&&!isRenewalTicket"
          class="mg-t-30">
          <ticket-remark :ticket-id="ticket_id"></ticket-remark>
        </div>
      </div>
      <div class="main flex-1">

        <section
          v-for="(item, index) in quoteList"
          v-show="index === activeQuote"
          :key="index">
          <div
            v-if="editType == 2 && item.customer_chose === 1"
            class="star-remark">
            <span class="star"></span>
            <span>The customer chose this quote on the client interface.</span>
          </div>
          <template v-if="productId>=80">
            <reply-new-sme-refer
              ref="sme-refer"
              :is-fina="isFina"
              :companyId.sync="company_id"
              :plan.sync="plan_name"
              :form-data-lock="formDataLock"
              :editType="editType"
              :renewOrderId="renewOrderId"
              :form="form"
              :item="item"
              @validate="handlerValidate"
            ></reply-new-sme-refer>
          </template>
          <template v-else>
            <housemaid-reply-refer-form
              v-if="productId == 12"
              ref="housemaid-reply-refer-form"
              :item="item"
              :customerId="customerId"
              :editType="editType"
              :reject_fileData="reject_fileData"
              :renewOrderId="renewOrderId"
              :index="index"
              :is-fina="isFina"
              :showBuyable="showBuyable"
              @delete="rejectDataHandleDel"
              @uploadSuccess="handlerUploadSuccess"
              @changePlan="changePlan"
              @getPremium="handlerReferralMain(index)"
              @validate="handlerValidate" />

            <working-reply-refer-form
              v-else-if="productId == 13"
              ref="working-reply-refer-form"
              :item="item"
              :customerId="customerId"
              :index="index"
              :is-fina="isFina"
              :showBuyable="showBuyable"
              :reject_fileData="reject_fileData"
              :editType="editType"
              :renewOrderId="renewOrderId"
              @delete="rejectDataHandleDel"
              @uploadSuccess="handlerUploadSuccess"
              @changePlan="changePlan"
              @getPremium="handlerReferralMain(index)"
              @validate="handlerValidate" />
            <travel-reply-refer-form
              v-else-if="productId == 14"
              ref="travel-reply-refer-form"
              :item="item"
              :customerId="customerId"
              :index="index"
              :showBuyable="showBuyable"
              :reject_fileData="reject_fileData"
              :editType="editType"
              :is-fina="isFina"
              :renewOrderId="renewOrderId"
              :formDataLock="formDataLock"
              @delete="rejectDataHandleDel"
              @uploadSuccess="handlerUploadSuccess"
              @changePlan="changePlan"
              @getPremium="handlerReferralMain(index)"
              @validate="handlerValidate" />
            <decoration-reply-refer-form
              v-else-if="productId == 15"
              ref="decoration-reply-refer-form"
              :item="item"
              :customerId="customerId"
              :index="index"
              :showBuyable="showBuyable"
              :reject_fileData="reject_fileData"
              :editType="editType"
              :is-fina="isFina"
              :renewOrderId="renewOrderId"
              :formDataLock="formDataLock"
              @delete="rejectDataHandleDel"
              @uploadSuccess="handlerUploadSuccess"
              @changePlan="changePlan"
              @getPremium="handlerReferralMain(index)"
              @validate="handlerValidate" />
            <student-reply-refer-form
              v-else-if="productId == 16"
              ref="student-reply-refer-form"
              :item="item"
              :index="index"
              :showBuyable="showBuyable"
              :reject_fileData="reject_fileData"
              :editType="editType"
              :renewOrderId="renewOrderId"
              :customerId="customerId"
              :is-fina="isFina"
              :referId="referId"
              @uploadSuccess="handlerUploadSuccess"
              @delete="rejectDataHandleDel"
              @changePlan="changePlan"
              @getPremium="handlerReferralMain(index)"
              @validate="handlerValidate" />
            <homefire-reply-refer-form
              v-else-if="productId == 17"
              ref="homefire-reply-refer-form"
              :item="item"
              :index="index"
              :showBuyable="showBuyable"
              :reject_fileData="reject_fileData"
              :editType="editType"
              :is-fina="isFina"
              :renewOrderId="renewOrderId"
              :customerId="customerId"
              :referId="referId"
              @delete="rejectDataHandleDel"
              @uploadSuccess="handlerUploadSuccess"
              @changePlan="changePlan"
              @getPremium="handlerReferralMain(index)"
              @validate="handlerValidate" />
            <personal-reply-refer-form
              v-else-if="productId == 18"
              ref="personal-reply-refer-form"
              :item="item"
              :index="index"
              :editType="editType"
              :renewOrderId="renewOrderId"
              :showBuyable="showBuyable"
              :reject_fileData="reject_fileData"
              :customerId="customerId"
              :referId="referId"
              :is-fina="isFina"
              @delete="rejectDataHandleDel"
              @uploadSuccess="handlerUploadSuccess"
              @changePlan="changePlan"
              @getPremium="handlerReferralMain(index)"
              @validate="handlerValidate" />
            <fire-reply-refer-form
              v-else-if="productId == 20"
              ref="fire-reply-refer-form"
              :item="item"
              :index="index"
              :showBuyable="showBuyable"
              :reject_fileData="reject_fileData"
              :editType="editType"
              :renewOrderId="renewOrderId"
              :customerId="customerId"
              :referId="referId"
              :is-fina="isFina"
              @delete="rejectDataHandleDel"
              @uploadSuccess="handlerUploadSuccess"
              @changePlan="changePlan"
              @getPremium="handlerReferralMain(index)"
              @validate="handlerValidate" />
            <pet-reply-refer-form
              v-else-if="productId == 22"
              ref="pet-reply-refer-form"
              :item="item"
              :index="index"
              :showBuyable="showBuyable"
              :reject_fileData="reject_fileData"
              :editType="editType"
              :renewOrderId="renewOrderId"
              :customerId="customerId"
              :referId="referId"
              :companyId.sync="item.company_id"
              @delete="rejectDataHandleDel"
              @uploadSuccess="handlerUploadSuccess"
              @changePlan="changePlan"
              @getPremium="handlerReferralMain(index)"
              @validate="handlerValidate" />
            <!-- motor  -->
            <template v-else-if="productId==11">
              <el-form
                ref="form"
                :model="item"
                :disabled="showBuyable"
                :rules="formRules">
                <div v-show="item.quote_status == 0 && editType == 3">
                  <div class="flex-sb">
                    <div class="form-item form-half">
                      <span>Insurer Quote Status</span>
                      <el-form-item
                        ref="quote_status"
                        prop="quote_status">
                        <v-radio-group
                          v-model="item.quote_status"
                          :border="true"
                          :list="quoteStatusOptions" />
                      </el-form-item>
                    </div>
                  </div>
                  <div class="box">
                    <div class="form-item form-half">
                      <span>Insurer</span>
                      <el-form-item
                        ref="company_id"
                        prop="company_id">
                        <v-select
                          v-model="item.company_id"
                          :list="localAllOptions.insurer"
                          :disabled="editType == 3 && index == 0"
                          @change="()=>(formDataLock+=1)" />
                      </el-form-item>
                    </div>
                    <div class="form-item form-half">
                      <span>Class of Insurance</span>
                      <el-form-item>
                        <v-select
                          v-model="item.plan_id"
                          :list="planList(item)"
                          :disabled="showBuyable"
                          @change="changeCarPlan" />
                      </el-form-item>
                    </div>
                    <div
                      v-if="item.quote_status == 0"
                      class="form-item form-half">
                      <span>Reject Renewal Notice</span>
                      <el-form-item
                        ref="renew_file_path_id"
                        prop="renew_file_path_id">
                        <v-upload
                          card
                          widthFull
                          :fileData="reject_fileData[index]"
                          :otherData="{
                            target: 'renew_file_path_id',
                            index,
                            name: ''
                          }"
                          @delete="rejectDataHandleDel"
                          @uploadSuccess="handlerUploadSuccess" />
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div v-show="(item.quote_status != 0 && editType == 3) || editType != 3">
                  <div class="flex-sb">
                    <div class="form-item form-half">
                      <span>Insurer Quote Status</span>
                      <el-form-item
                        ref="quote_status"
                        prop="quote_status">
                        <v-radio-group
                          v-model="item.quote_status"
                          :border="true"
                          :disabled="editType == 2"
                          :list="quoteStatusOptions" />
                      </el-form-item>
                    </div>
                    <div class="form-item form-half">
                      <span>Total Payable</span>
                      <span>{{ item.payable }}</span>
                    </div>
                  </div>
                  <div class="box">
                    <div class="flex-sb">
                      <div class="form-item form-half">
                        <span>Insurer</span>
                        <el-form-item
                          ref="company_id"
                          prop="company_id">
                          <v-select
                            v-model="item.company_id"
                            :list="localAllOptions.insurer"
                            :disabled="editType == 3 && index == 0"
                            @change="changeCarPlan" />
                        </el-form-item>
                      </div>
                      <div class="form-item form-half">
                        <span>Type of Insurance</span>
                        <v-select
                          v-model="item.class_id"
                          :disabled="true"
                          :list="classOptions" />
                      </div>
                    </div>
                    <div class="flex-sb">
                      <div class="form-item form-half">
                        <span>Class of Insurance</span>
                        <el-form-item>
                          <v-select
                            v-model="item.plan_id"
                            :list="planList(item)"
                            @change="changeCarPlan" />
                        </el-form-item>
                      </div>
                      <div class="form-item form-half">
                        <span>Policyholder</span>
                        <v-input
                          v-model="item.isrd_nm"
                          :disabled="true" />
                      </div>
                    </div>
                    <div class="flex-sb">
                      <div class="form-item form-half">
                        <span>Quotation Number</span>
                        <v-input
                          v-model="item.quote_no"
                          :disabled="true" />
                      </div>
                      <div class="form-item form-half">
                        <span>Type of quotation</span>
                        <v-select
                          v-model="item.type"
                          :disabled="true"
                          :list="globalOptions.quote_type" />
                      </div>
                    </div>
                  </div>
                  <div class="box">
                    <refer-underwriting
                      ref="refer-underwriting"
                      :form="item"
                      :index="index"
                      :class-id="classId"
                      :disabled="showBuyable"
                      :formDataLock="formDataLock"
                      :editType="editType"
                      :renewOrderId="renewOrderId"
                      @sendPlanCvrRemark="getPlanCvrRemark"
                      @getSubmitPremium="getSubmitPremium"
                      @getFormData="submitPremium" />
                    <!--                <h3>Underwriting Question</h3>-->
                    <!--                <div class="flex-sb-wrap">-->
                    <!--                  <div-->
                    <!--                    v-for="(inItem, inIndex) in item.underwriting"-->
                    <!--                    :key="inIndex"-->
                    <!--                    class="form-item form-half">-->
                    <!--                    <span>{{ inItem.name }}</span>-->
                    <!--                    <v-radio-group-->
                    <!--                      v-model="inItem.answer"-->
                    <!--                      :border="true"-->
                    <!--                      :disabled="showBuyable"-->
                    <!--                      :list="yesNoOptions" />-->
                    <!--                  </div>-->
                    <!--                </div>-->
                  </div>
                  <!--              <div-->
                  <!--                v-if="item.special_clause"-->
                  <!--                class="box">-->
                  <!--                <div class="">-->
                  <!--                  <span class="title">Special Clause</span>-->
                  <!--                  <p-->
                  <!--                    v-for="(special,i) in item.special_clause['en-US']||[]"-->
                  <!--                    :key="'special'+i"-->
                  <!--                    class="special-text">-->
                  <!--                    <span class="flex-1">{{i+1+'）'}}</span>-->
                  <!--                    <span  class="flex-2"> {{special.val}}</span>-->
                  <!--                  </p>-->
                  <!--                </div>-->
                  <!--              </div>-->
                  <show-special-clause
                    :form="item"
                    :index="index"></show-special-clause>
                  <template v-if="!isHzmb">
                    <div
                      class="box">
                      <h3>Excess</h3>
                      <excess-form
                        ref="excess-form"
                        :formDataLock="formDataLock"
                        :disabled="showBuyable"
                        :form="item"
                        :index="index"
                        @getSubmitExcess="getSubmitExcess"
                      />
                    </div>
                  </template>
                  <template v-if="classId == 14">
                    <div class="box">
                      <h3>Coverage</h3>
                      <div class="flex-sb">
                        <div class="form-half">
                          <div class="form-item">
                            <span>TPPD (Third Party Property Damage)</span>
                            <v-input
                              v-model="item.tppd_limit_amt"
                              :disabled="true"
                              maxlength="9"
                              :keyFloatNumber="true"
                              prepend="$"/>
                          </div>
                        </div>
                        <div class="form-half">
                          <div class="form-item">
                            <span>TPBI  (Third Party Bodily Injury)</span>
                            <el-form-item
                              :ref="`quoteList.${index}.tpbi_limit_amt`"
                              :rules="rules.tpbi_limit_amt"
                              prop="tpbi_limit_amt" >
                              <v-input
                                v-model="item.tpbi_limit_amt"
                                :disabled="showBuyable"
                                maxlength="9"
                                prepend="$"
                                :keyFloatNumber="true"/>
                            </el-form-item>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="plan_cvr_remark"
                        class="form-item">
                        <span>Plan Coverage Remark</span>
                        <span>{{plan_cvr_remark}}</span>
                      </div>
                      <div class="flex-sb">
                        <div class="form-half">
                          <div class="form-item">
                            <span>Coverage Remark</span>
                            <v-input
                              v-model="item.cvr_remark"
                              type="textarea"
                              :rows="3"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="box">
                      <benefit-form
                        ref="benefit-form"
                        :form="item"
                        :index="index"
                        :class-id="classId"
                        :disabled="showBuyable"
                        :formDataLock="formDataLock"
                        :editType="editType"
                        :renewOrderId="renewOrderId"
                        @getSubmitPremium="getSubmitPremium"
                        @getFormData="submitPremium" />
                    </div>
                  </template>
                  <template v-else>
                    <div
                      v-if="!isHzmb"
                      class="box">
                      <h3>Coverage</h3>
                      <div class="flex-sb">
                        <div
                          v-if="item.trm_of_cvr!=1"
                          class="form-half">
                          <div class="form-item">
                            <span>Own Damage </span>
                            <v-input
                              v-model="item.isrd_vl"
                              maxlength="9"
                              :keyFloatNumber="true"
                              prepend="$" />
                          </div>
                        </div>
                        <div class="form-half">
                          <div class="form-item">
                            <span>Third Party Death or Bodily Injury </span>
                            <el-form-item
                              :ref="`quoteList.${index}.tpbi_limit_amt`"
                              :rules="rules.tpbi_limit_amt"
                              prop="tpbi_limit_amt" >
                              <v-input
                                v-model="item.tpbi_limit_amt"
                                :disabled="showBuyable"
                                maxlength="9"
                                :keyFloatNumber="true"
                                prepend="$" />
                            </el-form-item>
                          </div>
                        </div>
                      </div>
                      <div class="flex-sb">
                        <div class="form-half">
                          <div class="form-item">
                            <span>Third Party Property Damage</span>
                            <v-input
                              v-model="item.tppd_limit_amt"
                              :disabled="true"
                              maxlength="9"
                              :keyFloatNumber="true"
                              prepend="$" />
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="plan_cvr_remark"
                        class="form-item">
                        <span>Plan Coverage Remark</span>
                        <span>{{plan_cvr_remark}}</span>
                      </div>
                      <div class="flex-sb">
                        <div class="form-half">
                          <div class="form-item">
                            <span>Coverage Remark</span>
                            <v-input
                              v-model="item.cvr_remark"
                              type="textarea"
                              :rows="3"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="box">
                      <benefit-form
                        ref="benefit-form"
                        :form="item"
                        :index="index"
                        :class-id="classId"
                        :disabled="showBuyable"
                        :formDataLock="formDataLock"
                        :editType="editType"
                        :renewOrderId="renewOrderId"
                        @getSubmitPremium="getSubmitPremium"
                        @getFormData="submitPremium" />
                        <!--                  <span class="title">More Benefits</span>-->
                        <!--                  <v-checkbox-group-->
                        <!--                    v-model="item.benefits"-->
                        <!--                    :block="true"-->
                        <!--                    :disabled="showBuyable"-->
                        <!--                    :list="localAllOptions.benefits" />-->
                    </div>
                  </template>
                  <template v-if="classId==11&&!isFina">
                    <extra-benefits-form
                      ref="extra-benefits"
                      :class-id="classId"
                      :form="item"
                      :index="index"
                      :disabled="showBuyable"
                      :formDataLock="formDataLock"
                      @submitExtraBenefit="submitPremium"
                      @changeExtra="changeExtraBenefits"
                      @changeExtraContent="changeExtraBenefits"
                    ></extra-benefits-form>
                  </template>
                  <div
                    class="box">
                    <h3>Remarks</h3>
                    <div class="form-half form-item">
                      <span>Policy Remark</span>
                      <v-input
                        v-model="item.cs_manual_remark"
                        type="textarea"
                        :disabled="showBuyable"
                        :rows="3" />
                    </div>
                  </div>
                  <premium-form
                    ref="premium"
                    :class-id="classId"
                    :customerId="customerId"
                    :form="item"
                    :index="index"
                    :modelId="form.model_id"
                    :disabled="showBuyable"
                    :extraData="item.extraData"
                    :formDataLock="formDataLock"
                    :refreshMain="refreshMain"
                    :extra_select="extra_select"
                    :unSelectKeys="unSelectKeys"
                    :benefitList='benefitList'
                    :editType="editType"
                    :is-fina="isFina"
                    :renewOrderId="renewOrderId"
                    :selectExtraBenefit="selectExtraBenefit"
                    @submitPremium="submitPremium"
                    @getSubmitPremium="getSubmitPremium"
                  ></premium-form>
                </div>
              </el-form>
            </template>
            <!--          <div v-if="productId==11">-->

            <!--          </div>-->
            <!--  -->

            <div
              v-show="!(item.quote_status == 0 && editType == 3)"
              class="box">
              <h3>Internal Use</h3>
              <div class="flex-sb">
                <div class="form-item form-half">
                  <span>Internal Remarks</span>
                  <v-input
                    v-model="item.internal_remark"
                    type="textarea"
                    :disabled="showBuyable"
                    :rows="6" />
                </div>
                <div class="form-half">
                  <div class="form-item">
                    <span>Proof Document</span>
                    <file-container
                      v-if="quoteList[index].proof_doc && quoteList[index].proof_doc.id"
                      :fileData="quoteList[index].proof_doc" />
                    <v-upload
                      :otherData="{
                        target: 'proof_doc',
                        index
                      }"
                      titleName= "Proof Document"
                      :orderUpload="true"
                      @uploadSuccess="handlerUploadSuccess" />
                  </div>
                  <div
                    v-if="classId !== 14"
                    class="form-item">
                    <span>Documents</span>
                    <file-container
                      v-for="(fileItem, fileIndex) in quoteList[index].documents"
                      :key="fileIndex"
                      :fileData="fileItem"
                      :edit="true"
                      :otherData="{
                        target: 'documents',
                        index,
                        fileIndex
                      }"
                      titleName= "Documents"
                      @delete="handlerDeleteFile"
                      @uploadSuccess="handlerUploadSuccess" />
                    <v-upload
                      :otherData="{
                        target: 'documents',
                        index
                      }"
                      :orderUpload="true"
                      @uploadSuccess="handlerUploadSuccess" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </section>
      </div>
    </div>
    <div
      v-if="isDev"
      class="text-block">
      <v-button
        type="danger"
        @click="handlerText">Auto Fill</v-button>
    </div>
    <send-email-sms
      ref="send-email-sms"
      :form="sendForm"
      :initContent="smsContent"
      :init-refer-content="smsContent"
      :emailListTitle="emailListTitle || list_title"
      :emailTitle="emailTitle || eamil_title"
      :all-select="isFina?false:all_select"
      :is-only-referrer="isFina"
      :is-renew="isRenew"
      :auto-renew="auto_on"
      :auto-pay-at="auto_pay_at"
      :updateContent="true"
      @send="handlerSend"
      @skip="handlerSkip"/>
    <select-send-message
      v-model="showAutoCloseSelectMessage"
      :form="form"
      :initSmsContent="auto_renew_close_data"
      :init-email-content="email_auto_renew_close_data"
      :init-share-content="share_auto_renew_close_data"
      :init-refer-content="editType == 3?renew_reply : smsContent"
      :is-only-referrer="isFina"
      :updateContent="true"
      @send="handlerRenewCloseSend"
      @skip="handlerRenewCloseSkip"></select-send-message>
    <select-send-message
      v-model="showAutoSelectMessage"
      :form="sendForm"
      :initSmsContent="renew_reply"
      :init-email-content="renew_email_reply"
      :init-share-content="renew_share_reply"
      :init-refer-content="isFina?renew_reply:renew_refer_reply"
      :is-only-referrer="isFina"
      :is-renew="isRenew"
      :auto-renew="auto_on"
      :auto-pay-at="auto_pay_at"
      :updateContent="true"
      @send="handlerRenewSend"
      @skip="handlerRenewSkip"></select-send-message>
  </section>
</template>
<script>
import {mapState} from 'vuex'
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
import MixinSendSMSEmail from '@/mixins/sendSMSEmail'
import MixinReplySame from '@/mixins/replySame'
import MixinSelectSendMessage from '@/mixins/selectSendMessage'
import MixinFormat from '@/mixins/format'
import MixinSMEReplyRefer from '@/mixins/sme-reply-refer'
import {changeReferralStts, getReferralMain, getReferralQuoteDel, replyReferral, sendReferralSms} from '@/api/refer'
import FileContainer from '@/views/components/file-container'
import ExcessForm from '@/views/tickets/components/form/excess-form'
import HousemaidReplyReferForm from './modules/housemaid/housemaid-reply-refer-form'
import DecorationReplyReferForm from './modules/decoration/decoration-reply-refer-form'
import HomefireReplyReferForm from './modules/homefire/homefire-reply-refer-form'
import travelReplyReferForm from './modules/travel/travel-reply-refer-form'
import studentReplyReferForm from './modules/student/student-reply-refer-form'
import workingReplyReferForm from './modules/working/working-reply-refer-form'
import personalReplyReferForm from './modules/personal/personal-reply-refer-form'
import fireReplyReferForm from './modules/homefire/fire-reply-refer-form'
import petReplyReferForm from './modules/pet/pet-reply-refer-form'
import PremiumForm from '@/views/components/premium-form'
import extraBenefitsForm from '@/views/components/extra_benefits'
import benefitForm from '@/views/tickets/components/modules/component/more-benefit'
import referUnderwriting from '@/views/tickets/components/form/refer-underwriting'
import showSpecialClause from '@/views/tickets/components/form/show-special-clause'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import {createRenewalReminderRemark, renewQuoteDel, renewReply, renewReplySend} from '@/api/renewal'
import {
  getQuoteDetail
} from '@/api/quote'
import OMath from '@/utils/math'
import TicketRemark from '@/views/tickets/components/ticket-remark'
import ReplyNewSmeRefer from '@/views/tickets/components/sme/reply-new-sme-refer'
import {getNewSMEQuoteDetail} from '@api/new_sme'

export default {
  name: 'ReplyRefer',
  components: {
    FileContainer,
    ExcessForm,
    HousemaidReplyReferForm,
    DecorationReplyReferForm,
    HomefireReplyReferForm,
    fireReplyReferForm,
    travelReplyReferForm,
    studentReplyReferForm,
    workingReplyReferForm,
    personalReplyReferForm,
    PremiumForm,
    SendEmailSms,
    extraBenefitsForm,
    benefitForm,
    referUnderwriting,
    showSpecialClause,
    petReplyReferForm,
    TicketRemark,
    ReplyNewSmeRefer
  },
  mixins: [MixinOptions, MixinRules, MixinFormat,MixinSendSMSEmail,MixinSelectSendMessage,MixinSMEReplyRefer,MixinReplySame],
  props: {
    editType: {
      type: Number,
      default: 1 // 1 - reply, 2 - upgrade, 3 - renew
    },
    customerId: {
      type: [Number,String],
      default: '' // 1 - reply, 2 - upgrade
    },
    extraData: {
      type: Array,
      default: () => ([]) // 1 - reply, 2 - upgrade
    },
    // detail 接口數據
    form: {
      type: Object,
      default: () => ({})
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    fromEdit: {
      type: Boolean,
      default: false
    },
    renewOrderId: {
      type: [Number, String],
      default: 0
    },
    hasEndorsNum: {
      type: Boolean,
      default: false
    },
    hasClaimNum: {
      type: Boolean,
      default: false
    },
    isFina: {
      type: Boolean,
      default: false
    },
    isDraft: {
      type: Boolean,
      default: false
    },
    isRenewalTicket: {
      type: Boolean,
      default: false
    },
  },
  data() {
    const check = (rule, value, callback) => {
      if(value>1000000000) {
        callback(new Error(this.$t('最大輸入範圍不能大於10億')))
      }
      callback()
    }
    const quoteItem = {
      title: 'New Quote',
      is_buyable_choose: true
    }
    return {
      referReplyType: 0,
      isSend: 1,
      smsContentResult: '',
      formDataLock: 0,
      refreshMain: 0,
      activeQuote: 0,
      quoteItem,
      sendForm:{},
      quoteList: [],
      // 廢棄 pass
      formData: {
        quo_id: '',
        quote_status: 1,
        company_id: '',
        class_id: '',
        refer_id: '',
        trm_of_cvr: '',
        customer_id: '',
        period: '',
        parking_damage_ex: '',
        underwriting: [],
        tppd_ex: '',
        tppd_young_driver_ex: '',
        tppd_inexp_driver_ex: '',
        tppd_unnamed_driver_ex: '',
        remark: '',
        tppd_limit_amt: '',
        tpbi_limit_amt: '',
        internal_remark: '',
        proof_doc: null,
        documents: null,
        young_driver_ex: '',
        inexp_driver_ex: '',
        unnamed_driver_ex: '',
        isrd_vl: '',
        benefits: [],
        cs_manual_remark: '',
        // excess
        loading_pct: '',
        // base_prm: '',
        cfd_pct: '',
        srd_pct: '',
        code_disc_pct: '',
        surcharge: '',
        mib_pct: '',
        ia_levy_pct: '',
        spec_disc_pct: '',
        handling_fee: '',
        additional_charge: '',
        base_prm: '',
        srd_amt: '',
        loading_amt: '',
        cfd_amt: '',
        code_disc_prm: '',
        mib_vl: '',
        model_id: '',
        ia_levy_vl: '',
        spec_disc_prm: '',
        payable: '',
        // 待填
        china_general_ex: '',
        // china_general_ex_typ: '',
        // china_general_ex_vl: '',
        china_theft_loss_ex: '',
        // china_theft_loss_ex_typ: '',
        // china_theft_loss_ex_vl: '',
        general_ex: '',
        // general_ex_typ: '',
        // general_ex_vl: '',
        theft_loss_ex: '',
        // theft_loss_ex_typ: '',
        // theft_loss_ex_vl: '',
        //
        quote_no: '',
        quote_dt: '',
        isrd_fst_nm: '',
        isrd_lst_nm: '',
        isrd_nm: '',
        type: '',
        extra_benefits:[]
      },
      typeQuotation: [
        // new: 10  renew: 20  endorsement:30;  cancel: 40
        {
          id: 10,
          name: 'New Business'
        },
        {
          id: 20,
          name: 'Renew'
        },
        {
          id: 30,
          name: 'Endorsement'
        },
        {
          id: 40,
          name: 'Cancel'
        }
      ],
      tempFormData: {
        ...quoteItem,
        periodDate: [],
        quo_id: '',
        quote_status: 1,
        company_id: '',
        class_id: '',
        refer_id: '',
        trm_of_cvr: '',
        customer_id: '',
        period: '',
        parking_damage_ex: '',
        underwriting: [],
        tppd_ex: '',
        tppd_young_driver_ex: '',
        tppd_inexp_driver_ex: '',
        tppd_unnamed_driver_ex: '',
        remark: '',
        tppd_limit_amt: '',
        tpbi_limit_amt: '',
        internal_remark: '',
        proof_doc: null,
        documents: null,
        young_driver_ex: '',
        inexp_driver_ex: '',
        unnamed_driver_ex: '',
        isrd_vl: '',
        // benefits: [],
        cvr_remark: '',
        cs_manual_remark: '',
        // excess
        loading_pct: '',
        // base_prm: '',
        cfd_pct: 0,
        srd_pct: 0,
        code_disc_pct: 0,
        surcharge: 0,
        mib_pct: 0,
        ia_levy_pct: 0,
        spec_disc_pct: 0,
        handling_fee: 0,
        additional_charge: 0,
        base_prm: 0,
        srd_amt: 0,
        loading_amt: 0,
        cfd_amt: 0,
        code_disc_prm: 0,
        mib_vl: 0,
        ia_levy_vl: 0,
        spec_disc_prm: 0,
        payable: 0,
        // 裝修工程
        mat_dam_prm: 0,
        tppd_limit_prm: 0,
        ec_levy_pct: 0,
        ec_levy_vl: 0,
        // 待填
        china_general_ex: '',
        // china_general_ex_typ: '',
        // china_general_ex_vl: '',
        china_theft_loss_ex: '',
        // china_theft_loss_ex_typ: '',
        // china_theft_loss_ex_vl: '',
        general_ex: '',
        // general_ex_typ: '',
        // general_ex_vl: '',
        theft_loss_ex: '',
        // theft_loss_ex_typ: '',
        // theft_loss_ex_vl: '',
        //
        quote_no: '',
        quote_dt: '',
        isrd_fst_nm: '',
        isrd_lst_nm: '',
        isrd_nm: '',
        type: '',
        basic_prm: 0,
        // housemaid
        employer_liability: '',
        personal_accident: '',
        clinical_expenses: '',
        loss_of_services: '',
        surgical_hospital_expenses: '',
        repatriation_expenses: '',
        dental_expenses: '',
        replacement_helper_expenses: '',
        benefits: [],
        benefit_coverage: {},
        plan_id: '',
        //  housemaid 新增
        surgical_ex: '',
        person_eff_ex: '',
        fidelity_cov_ex: '',
        person_lia_ex: '',
        // decoration
        mat_dam_ex: '',
        principal_prop_ex: '',
        water_dmge_ex: '',
        material_damage: '',
        pcy_cmnt_dt: '',
        pcy_expry_dt: '',
        // Home & Fire
        contents_cover: '',
        personal_liability_cover: '',
        additional_accommodation_exp: '',
        personal_guard: '',
        extra_benefits:[]
      },
      validateResult: [], // 存儲校驗結果
      extra_select:[],
      // extraData:[],
      subForm: {
        // 'extra-benefits':false,
        'premium':false,
        // 'benefit-form':false,
      },
      extraRules: {
        tpbi_limit_amt: [
          {validator: check, trigger: ['change', 'blur']}
        ],
      },
      plan_cvr_remark: '',
      unSelectKeys: [],
      benefitList: [],
      selectExtraBenefit: [], //选中的extra benefit默认值
      reply_content: '',
      reject_content: '',
      list_title: '',
      eamil_title: '',
      reject_fileData: {},
      tempCase: {},
      type_list: [],
      temp: {
        tppd_ex: '',
        tppd_young_driver_ex: '',
        tppd_inexp_driver_ex: '',
        tppd_unnamed_driver_ex: '',
        remark: '',
        general_ex: '',
        general_ex_posi:'',
        general_ex_or_pol:'',
        china_general_ex: '',
        china_general_ex_posi: '',
        china_general_ex_or_pol: '',
        theft_loss_ex: '',
        theft_loss_ex_posi: '',
        theft_loss_ex_or_pol: '',
        china_theft_loss_ex: '',
        china_theft_loss_ex_posi: '',
        china_theft_loss_ex_or_pol: '',
        parking_damage_ex: '',
        young_driver_ex: '',
        inexp_driver_ex: '',
        unnamed_driver_ex: '',
        handling_fee: 0,
        surcharge:0,
        spec_disc_prm: 0,
        promo_disc_prm: 0,
        coupon_vl: 0,
        coupon_code: '',
        code_disc_prm: 0,
        code: '',
        code_disc_pct: 0,
        basic_prm: 0,
        base_prm: 0,
        payable: 0,
        mib_vl: 0,
        mib_pct: 0,
        ia_levy_pct: 0,
        ia_levy_vl: 0,
        ec_levy_vl: 0,
        plan_type:'',
        benefit_premium:'',
        extra_benefits_content:[],
        min_premium: '',
        gross: 0,
        main_policy_amount: 0,
        chooseCode: false,
        chooseCoupon: false,
        internal_remark: '',
        cs_manual_remark: '',
        cvr_remark: '',
        tppd_limit_amt: '',
        tpbi_limit_amt: '',
        isrd_vl: '',
        proof_doc: {},
        quo_id: 0,
        company_id: null,
        quote_status: 1
      },
      coverage:{
        medical_expenses:'',
        hospital_cash:'',
        travel_delay:'',
        trip_cancellation:'',
        burns_benefit:'',
        baggage_delay:'',
        personal_accident:'',
        rental_vehicle_excess:'',
        worldwide_service:'',
        personal_property:'',
        personal_liability:'',
        home_protection:'',
        loss_of_documents:'',
        personal_money:'',
        credit_protection:'',
        cvr_remark:'',

        tppd_limit_amt:'',
        tpbi_limit_amt:'',
        isrd_vl:'',

        medical_coverage:'',
        veter_consul_fee:'',
        prescribed:{times:'',years:''},
        room_and_board:'',
        clinical_surgical:'',
        hird_party_lia:'',
        holiday_cancel:'',
        overseas_coverage:'',
        emergency_board:'',
      },
      excess:{
        tppd_ex:'',
        tppd_young_driver_ex:'',
        tppd_inexp_driver_ex:'',
        tppd_unnamed_driver_ex:'',
        remark:'',
        general_ex:'',
        general_ex_posi:'',
        general_ex_or_pol:'',
        china_general_ex:'',
        china_general_ex_posi:'',
        china_general_ex_or_pol:'',
        theft_loss_ex:'',
        theft_loss_ex_posi:'',
        theft_loss_ex_or_pol:'',
        china_theft_loss_ex:'',
        china_theft_loss_ex_posi:'',
        china_theft_loss_ex_or_pol:'',
        parking_damage_ex:'',
        young_driver_ex:'',
        inexp_driver_ex:'',
      },
      premium_obj:{
        basic_prm:'',
        base_prm:'',
        ia_levy_pct:'',
        benefit_premium:{
          skydiving:'',
          cameras:'',
          mobile_phone:'',
          journey_interruption:'',
          rental_vehicle_excess:'',
        },
        gross:'',
        main_policy_amount:'',
      },
      first: true,
      BuyableDisabled: false,
      all_select: true,
      renew_discount_type:1,
      is_renew_send:0,
      renew_discount_reply_data:'',
      reject_send_data:'',
      renew_send_type:'',
      send_type:'',
      auto_send:{
        is_send_sms_auto_renew_close:0,
        is_send_email_auto_renew_close:0,
        auto_renew_close_content:'',
      },
      detailData:{},
      showSelectMessage:false,
    }
  },
  computed: {
    ...mapState('ticket', ['ticketData', 'quoteCase', 'ticketReferForm']),
    ...mapState('renewal', ['renewSendData']),
    ticket_id(){
      let {ticket_id} = this.$route.query||{}
      return ticket_id
    },
    auto_on(){
      let {pre_auto_renewal_info,auto_renewal_info} = this.detailData||{}
      let {auto_on} = pre_auto_renewal_info||{}
      if(this.isFirstAutoReject) return false
      return auto_on||false
    },
    auto_pay_at(){
      let {pre_auto_renewal_info,auto_renewal_info} = this.detailData||{}
      let {auto_pay_at} = pre_auto_renewal_info||{}
      return auto_pay_at
    },
    show_auto_reject(){
      let {pre_auto_renewal_info,auto_renewal_info={}} = this.detailData||{}
      let {disable_on,auto_on } =pre_auto_renewal_info||{}
      return !disable_on&&auto_on&&this.isFirstAutoReject
    },
    planList() {
      return (item)=>{
        if(!this.globalOptions || !this.globalOptions.plan) {
          return []
        }
        let {plan=[]} = this.globalOptions||{}
        const { class_id, company_id } = item
        const key = `${company_id}${class_id}`
        return plan.filter(item => item.category_id == key)
      }
    },
    isRenew(){
      return this.editType == 3
    },
    // base_prm、srd_pct、loading_pct、cfd_pct、code_disc_pct、mib_pct、ia_levy_pct、
    // spec_disc_pct、handling_fee、additional_charge、base_prm
    isHasQuote(){
      let flag = false
      let list = this.quoteList
      if(this.editType !== 1) {
        list = this.quoteList.filter(item => item.is_buyable_choose)
      }
      list.some(item => {
        const { quote_status } = item
        if(quote_status == 1) {
          flag = true

        }
      })
      return flag
    },
    isFirstAutoReject(){
      let flag = false
      let list = this.quoteList||[]
      if(this.editType == 3) {
        this.quoteList.filter((item,index) => {
          if(item.quote_status==0&&index==0)
            flag = true
        })
        if(list.length>1)
          flag = true
      }
      return flag
    },
    smsContent() {
      const {
        refer_purchase_url_data,
        refer_ready_url_data,
        refer_reject_url_data
      } = this.form||{}
      if(!this.isHasQuote) {
        let className = this.getOptionName('classOptions', this.classId)
        let msg =''
        if(refer_reject_url_data)
          msg = refer_reject_url_data.replace('{{product_language}}', className)
        if(this.isFina)
          return this.initReferRejectContent
        return msg
      }
      return this.referReplyType == 1?
        refer_ready_url_data:
        refer_purchase_url_data
    },
    emailListTitle() {
      const {
        refer_purchase_url_list_title,
        refer_ready_url_list_title,
        refer_reject_url_list_title
      } = this.form||{}
      if(!this.isHasQuote) {
        return refer_reject_url_list_title
      }

      return this.referReplyType == 1?
        refer_ready_url_list_title:
        refer_purchase_url_list_title
    },
    emailTitle() {
      const {
        refer_purchase_url_title,
        refer_ready_url_title,
        refer_reject_url_title
      } = this.form||{}
      if(!this.isHasQuote) {
        return refer_reject_url_title
      }
      return this.referReplyType == 1?
        refer_ready_url_title:
        refer_purchase_url_title
    },
    formRules() {
      const {quote_status} = this.quoteList[0]
      var rule = JSON.stringify(this.rules)
      const data =[
        'base_prm',
        'srd_pct',
        'loading_pct',
        'cfd_pct',
        'code_disc_pct',
        'mib_pct',
        'ia_levy_pct',
        'spec_disc_pct',
        'additional_charge',
        'handling_fee',
      ]
      rule = JSON.parse(rule)
      data.forEach(item=>{
        rule[item][0].required =false
      })
      // return this.rules
      return quote_status==0? rule:this.rules
    },
    productId() {
      return this.form.product_id || 11
    },
    classId() {
      // return 14
      return this.form.class_id || 14
    },
    isHzmb(){
      return this.classId ==15
    },
    referId() {
      return this.form.refer_id
    },
    localAllOptions() {
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    special_clause_list(){
      let index = this.activeQuote
      let data = this.quoteList[index]||{}
      let {special_clause = {}} = data||{}
      return  special_clause?special_clause['en-US']||[]:[]

    },
    title(){
      return this.editType == 3? 'Add Renew Quote' : 'Reply Refer Case Quote'
    },
    init_content(){
      let amount = ''
      let content = this.reply_content
      let gross = ''
      this.quoteList.some(item => {
        let {extra_benefits_content} = item||{}
        if(item.quote_status == 1){
          amount = item.payable
          gross = item.gross
          if(extra_benefits_content){
            Object.keys(extra_benefits_content).forEach(key => {
              if(Number(extra_benefits_content[key].gross)>0)
                gross = Number(gross) + Number(extra_benefits_content[key].gross)
            })
          }
          return true
        }
      })
      if(typeof amount == 'number'){
        let money = OMath.formatMoney(amount,2,true)
        let gross_money = OMath.formatMoney(gross,2,true)
        content = content.replace('{{gross}}', gross_money)
        if(amount == gross){
          content = content.replace('after discount is {{amount}},', '')
          content = content.replace('，折扣後 {{amount}}', '')
          // if(this.isSME)
          content = content.replace('{{amount}}', money)
        }else{
          content = content.replace('{{amount}}', money)
        }
      }else{
        content = this.reject_content
      }
      return content
    },

    renew_reply(){
      let list = this.quoteList
      let flag = false
      list.some(item => {
        const { quote_status } = item
        if(quote_status == 1) {
          flag = true
        }
      })
      if(!flag){
        if(this.isFina)
          return this.initReferRejectContent
        return this.reject_content
      }
      return this.init_content
    },

  },
  watch: {
    localAllOptions: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val && val.underwriting) {
          const underwriting = val.underwriting.reduce((result, item) => {
            result.push({
              ...item,
              answer: ''
            })
            return result
          }, [])
          this.$set(this.tempFormData, 'underwriting', underwriting)
        }
      }
    },
    quoteCase: {
      immediate: true,
      handler(val) {
        this.initData() // 初始化參數
        if(val && val.length > 0) {
          this.formDataLock += 1
          this.quoteList = val.reduce((result, item, index) => {
            // this.completeObject(item)
            let company = ''
            let trm_of_cvr = ''
            if(this.productId==11){
              this.getInitPlanList(item,index)
            }
            if(!this.isSME)
            {
              company = this.getLocalAllOptionName('insurer', item.company_id)
              trm_of_cvr = this.getOptionName('coverTypeOptions', item.trm_of_cvr)
            }else {
              this.company_id = item.company_id
            }

            if(this.editType == 3){
              var temp = JSON.parse(JSON.stringify(item))
              this.tempCase = JSON.parse(JSON.stringify(item))
              if(item.renew_discount_reply_data){
                this.renew_discount_reply_data = item.renew_discount_reply_data
              }
              this.reject_fileData[index] = JSON.parse(JSON.stringify(item.renew_file))
            }else{
              var temp = JSON.parse(JSON.stringify(this.tempFormData))
            }
            // Home & Fire 的 Excess 是动态的，这里添加个字段
            if(this.productId == 17) {
              temp.excess = []
            }
            temp = Object.assign(temp, item)
            temp.isrd_nm = this.form.isrd_nm
            temp = JSON.parse(JSON.stringify(temp))
            // 要處理 title
            let title = `${company} - ${trm_of_cvr}`

            // if(this.productId != 11) {
            let planName = this.handler().getPlanName(item)
            // console.log(planName)
            title = `${company} - ${planName}`
            // }
            if(this.productId==11&&this.classId==11){
              let {extra_benefits_content} = JSON.parse(JSON.stringify(temp))||{}

              // temp.extra_benefits_content = {
              //   ...this.tempFormData.extra_benefits_content,
              //   ...temp.extra_benefits_content,
              // }
              //
              // temp.extraData = Object.entries(temp.extra_benefits_content).map(item=>{
              //   item[1].id = Number(item[1].id)
              //   return item[1]
              // })
            }
            if(([11,14,22].includes(this.productId))&&this.editType==3){
              Object.keys(this.coverage).some(key=>{
                if(key in item){
                  temp[key] = item[key]?item[key]:this.coverage[key]
                }
              })
              if(this.productId==11){
                Object.keys(this.excess).some(key=>{
                  if(key in item){
                    temp[key] = item[key]?item[key]:this.excess[key]
                  }
                })
              }
              if(this.productId==14){
                Object.keys(this.premium_obj).some(key=>{
                  if(key in item){
                    temp[key] = item[key]?item[key]:this.premium_obj[key]
                  }
                })
              }
            }
            result.push({
              ...temp,
              title,
              is_buyable_choose:1,
              // plan_id: 1,
              // class_id: 21
              // periodDate
            })
            return result
          }, [])
        } else {
          if(this.ticketReferForm != null||this.isSME){
            return
          }
          // 没有 draft，直接默认给一个
          let temp = JSON.parse(JSON.stringify(this.tempFormData))
          if(this.productId==11)
            this.getInitPlanList(temp,0)
          if(this.productId == 17) {
            temp.excess = []
          }
          if(this.productId==11&&this.classId==11) {
            temp.extraData = this.extraData
          }
          if(this.productId==22){
            temp.prescribed = {times :'', years : ''}
          }
          if(this.productId==14&&this.editType==3){
            temp = {
              ...temp,
            }
          }

          this.formDataLock += 1
          this.quoteList = [{
            ...temp,
            is_buyable_choose: 1
            // periodDate: []
          }]
        }
        // this.formData = Object.assign(this.formData, this.quoteList[0])
        this.activeQuote = 0
      }
    },
    productId: {
      immediate: true,
      handler(val) {
        if(val == 11) {
          this.changeCarPlan()
        }
      }
    },
    quoteList: {
      immediate: true,
      deep: true,
      handler(val){
        if(this.editType == 2){
          let res = true
          val.map(item => {
            item.is_buyable_choose =1
            // if(item.is_buyable_choose){
            //   this.BuyableDisabled = false
            //   res = false
            // }
            // console.log('zzz--',item.is_buyable_choose,res)
            // if(res){
            //   this.BuyableDisabled = true
            // }
            if(!item.payable){
              item.payable = 0
            }
          })
        }
      }
    },

    formDataLock:{
      immediate: true,
      handler(){
        this.first = true
      }
    },

    ticketReferForm:{
      immediate: true,
      deep: true,
      handler(val){
        let {quote_status,tpbi_limit_amt,tppd_limit_amt} = val||{}
        let params = {}
        if(this.productId == 11) {
          params.tpbi_limit_amt = tpbi_limit_amt||100000000
          const valueObj = {
            11: 2000000,
            12: 1000000,
            14: 750000,
            13: 750000,
          }
          if(this.classId==13)
            params.tppd_limit_amt = 750000
          // params.tppd_limit_amt = tppd_limit_amt||valueObj[Number(this.classId)]
        }
        if(val && this.quoteCase.length == 0&&!this.isSME){
          this.quoteList = [{
            ...val,
            ...params,
            quote_status:quote_status?quote_status:1
          }]
        }
      }
    },

    editType:{
      immediate: true,
      handler(val){
        if(val == 2){
          this.quoteList.forEach(item =>{
            item.quote_status = 1
          })
        }
      }
    },
    renewSendData:{
      immediate:true,
      handler(val){
        let {is_renew_discount,renew_discount_reply_data}  =val||{}
        if(is_renew_discount==1){
          this.renew_discount_type = 2
          this.renew_discount_reply_data = renew_discount_reply_data
        }
        else  this.renew_discount_type = 1
      }
    }

  },
  methods: {
    handlerSkip() {
      this.smsContentResult = ''
      this.isSend = 0
      this.renew_send_type = ''
      // if(this.editType == 3){
      //   this.$emit('reply-all')
      // }else{
      if(this.referReplyType == 1) {
        this.onReplyAll()
      }
      else {
        this.onComplete()
      }
      // }
    },
    handlerRenewSkip(data) {
      this.renew_send_data = {}
      if(this.referReplyType == 1) {
        this.onReplyAll()
      }
      else {
        this.onComplete()
      }
    },
    handlerRenewCloseSkip() {
      this.auto_send.is_send_sms_auto_renew_close =0
      this.auto_send.is_send_email_auto_renew_close =0
      this.auto_send.is_send_share_auto_renew_close =0
      this.auto_send.auto_renew_close_content =''
      this.auto_send.auto_renew_close_email_content =''
      this.auto_send.auto_renew_close_share_content =''
      this.showAutoSelectMessage = true
    },
    handlerSend(content,send_type,data) {
      let {referrer_content} = data
      this.smsContentResult = this.isFina?referrer_content:content
      this.isSend = 1
      // if(this.editType == 3){
      //   this.network().renewReplySend()
      // }else{
      if(this.editType==3){
        this.renew_send_type = send_type
      }
      if(this.editType==2){
        this.send_type = send_type
      }
      if(this.referReplyType == 1) {
        this.onReplyAll()
      }
      else {
        this.onComplete()
      }
      // }
      // this.network().sendReferralSms(content)
    },
    handlerRenewSend(data) {
      this.renew_send_data = data
      if(this.referReplyType == 1) {
        this.onReplyAll()
      }
      else {
        this.onComplete()
      }
      // }
      // this.network().sendReferralSms(content)
    },
    handlerRenewCloseSend(data) {
      let {is_sms_send,content,email_content,share_content,is_share_send,is_email_send} = data ||{}
      this.auto_send.is_send_sms_auto_renew_close =is_sms_send
      this.auto_send.is_send_email_auto_renew_close =is_email_send
      this.auto_send.is_send_share_auto_renew_close =is_share_send
      this.auto_send.auto_renew_close_content =content
      this.auto_send.auto_renew_close_email_content =email_content
      this.auto_send.auto_renew_close_share_content =share_content
      this.showAutoSelectMessage = true
    },
    handleCancel(){
      this.first = true
      this.$emit('cancel')
    },
    // plan 數據， housemaid 會根據 class id 和 company id 變
    planOptions(index) {
      const { class_id, company_id } = this.quoteList[index]
      if(!class_id || !company_id) return []

      const key = `${company_id}${class_id}`
      const { plan } = this.globalOptions
      const options = plan[key]
      if(!options) return []
      return options
    },
    changeCompany(index) {
      // if(this.productId != 11) {
      this.$set(this.quoteList[index], 'plan_id', '')
      // }
    },
    initData() {
      // Object.keys(this.tempFormData).some(key => {
      //   if(this.form[key]) {
      //     this.tempFormData[key] = JSON.parse(JSON.stringify(this.form[key]))
      //   }
      // })
      let form = JSON.parse(JSON.stringify(this.form))
      if(!form.underwriting) {
        delete form.underwriting
      }
      let underwriting = []
      if(this.localAllOptions && this.localAllOptions.underwriting) {
        underwriting = this.localAllOptions.underwriting.reduce((result, item) => {
          result.push({
            ...item,
            answer: ''
          })
          return result
        }, [])
      }

      const params = Object.assign(this.tempFormData, this.form)
      if(!params.underwriting) {
        params.underwriting = underwriting
      }

      if(this.productId == 11) {
        params.tpbi_limit_amt = 100000000
        const valueObj = {
          11: 2000000,
          12: 1000000,
          14: 750000,
          13: 750000
        }
        if(this.classId==13)
          params.tppd_limit_amt = 750000
        // if(this.classId==11){
        //   let obj = JSON.parse(JSON.stringify(this.extraData))
        //   params.extra_benefits_content = {}
        //   obj.forEach(item=>{
        //     let key = item.key
        //     params.extra_benefits_content[key] = item
        //   })
        // }
      }
      if(this.editType==3&&(this.productId==14||this.productId==11)){
        Object.keys(this.coverage).some(key=>{
          if(key in this.form){
            this.coverage[key] = this.form[key]
          }
        })
        if(this.productId==14)
        {
          Object.keys(this.premium_obj).some(key=>{
            if(key in this.form){
              this.premium_obj[key] = this.form[key]
            }
          })
        }
        if(this.productId==11)
        {
          Object.keys(this.excess).some(key=>{
            if(key in this.form){
              this.excess[key] = this.form[key]
            }
          })
        }
      }
      this.tempFormData = JSON.parse(JSON.stringify(params))
      // this.formData = JSON.parse(JSON.stringify(this.tempFormData))
    },
    handlerText() {
      this.quoteList.some(item => {
        Object.assign(item, {
          // quote_dt: '2020-04-30',
          period: '2020-05-06',
          tppd_ex: 2000,
          tppd_young_driver_ex: 2000,
          tppd_inexp_driver_ex: 2000,
          tppd_unnamed_driver_ex: 2000,
          remark: 'Nothing',
          tppd_limit_amt: 200,
          tpbi_limit_amt: 200,
          china_general_ex: 200,
          general_ex: 200,
          theft_loss_ex: 200,
          china_theft_loss_ex: 200,
          parking_damage_ex: 200,
          young_driver_ex: 200,
          inexp_driver_ex: 200,
          unnamed_driver_ex: 200,
          isrd_vl: 2000,
          cs_manual_remark: 'N/A',
          base_prm: 2000,
          srd_pct: 10,
          loading_pct: 10,
          cfd_pct: 10,
          code_disc_pct: 10,
          mib_pct: 10,
          ia_levy_pct: 10,
          spec_disc_pct: 10,
          handling_fee: 1000,
          additional_charge: 1000
        })
        item.underwriting.map(item => {
          item.answer = 0
          return item
        })
      })
    },
    // completeObject(o) {
    //   let result = []
    //   for(let key in this.tempFormData) {
    //     if(!(key in o)) {
    //       result.push(key)
    //     }
    //   }
    //   console.log(result, '===')
    // },
    getLocalAllOptionName(target, value) {
      if(this.isSME)
        return
      if(this.classId == 14) {
        return this.getAllOptionName(target, value)
      }
      else {
        return this[`getAllOptionName${this.classId}`](target, value)
      }
    },
    handlerValidate({ index }) {
      this.validateResult[index] = true
    },
    handlerAddQuote() {
      let tempFormData
      if(this.editType == 3){
        // renew初始化表单数据quote_status
        tempFormData = JSON.parse(JSON.stringify(this.tempCase))
        Object.assign(tempFormData, this.temp)
        let {plan_type} = this.tempCase||{}
        tempFormData.plan_type =plan_type

        // 获取premium表单
        let premiumData = []
        switch(this.productId){
          case 11:
            premiumData = JSON.parse(JSON.stringify(this.$refs['premium'][this.activeQuote].premium))
            break
          case 18:
            premiumData = JSON.parse(JSON.stringify(this.$refs['personal-reply-refer-form'][this.activeQuote].$refs['premium'].premium))
        }
        // let premiumData = this.$refs['premium'][this.activeQuote].premium
        const res = premiumData.reduce((result, item) => {
          const { name, style,name2 } = item
          if(style == 2) {
            result.push(`${name}_amt`)
            result.push(`${name}_pct`)
          }
          if(style == 3) {
            result.push(`${name}_vl`)
          }
          if(style == 5) {
            result.push({style:5,name,name2})
          }
          else {
            result.push(name)
          }
          return result
        }, [])
        res.map(item => {
          tempFormData[item] = 0
        })
      }else{
        tempFormData = JSON.parse(JSON.stringify(this.tempFormData))
      }
      if(tempFormData.customer_chose){
        tempFormData.customer_chose = 0
      }
      tempFormData.extraData = this.extraData
      const index = this.quoteList.length
      let params =  {tempFormData,...this.form,is_renew_discount:1}
      params.quo_id = ''
      params.quote_status = 1
      if(params.class_id==23&&params.plan_type==2&&this.editType==3)
      {
        params.coupon_code = ''
        params.campaign_code = ''
      }
      if(this.editType==3){
        if([11,14,22].includes(this.productId)){
          Object.keys(this.coverage).some(key=>{
            params[key] =null
          })
          if(this.productId==22){
            params.prescribed = {times :'', years : ''}
          }
        }
        if(this.productId==14){
          Object.keys(this.premium_obj).some(key=>{
            params[key] = null
          })
        }
        if(this.productId==11){
          Object.keys(this.excess).some(key=>{
            params[key] = null
          })
        }
      }
      this.getInitPlanList(params,index)
      this.$set(this.quoteList, index,params)
      this.activeQuote = index
      // const oldIndex = this.activeQuote
      // this.quoteList.push(tempFormData)
      // 先保存當前填的數據
      // Object.assign(this.quoteList[oldIndex], this.formData)
      // this.activeQuote = this.quoteList.length - 1
      // this.formData = tempFormData
    },
    changeActiveQuote(index) {
      // const oldIndex = this.activeQuote
      // Object.assign(this.quoteList[oldIndex], this.formData)
      if([11,12,14].includes(this.classId))
      {
        this.formDataLock+=1
      }
      this.activeQuote = index
      // this.formData = this.quoteList[index]
    },
    handleDeleteQuote(item,index){
      let {quo_id=''} = item||{}
      if(quo_id){
        let data = {
          params: {
            order_id:this.form.order_id,
            quo_id
          },
          index
        }
        this.network().getReferralQuoteDel(data)
      }else
      {
        this.quoteList.splice(index,1)
        setTimeout(()=>{
          this.activeQuote = 0
        },50)
      }
    },
    async onSaveDraft() {
      const valid =await this.handler().validateForm()
      if(!valid) return

      const params =await this.handler().handlerReplyParams(1)
      this.network().replyReferral(params)
    },
    async clickNext(type){
      const valid =await this.handler().validateForm()
      if(!valid) return
      this.$emit('update')
      if(this.hasClaimNum || this.hasEndorsNum){
        this.$emit('nextStep', 3)
      }else{
        this.onReferralSendSms(type)
      }
    },
    async onReferralSendSms(type) {
      const valid =await this.handler().validateForm()
      if(!valid) return

      this.referReplyType = type
      // if(this.editType == 3){
      //   this.onReplyAll()
      // }else{
      await this.handler().updateQuoteDetailData()
      let is_reject = true
      let is_first_reject = false
      let params =await this.handler().handlerReplyParams(this.editType==3?2:type)
      if(this.editType==3){
        // const params = this.handler().handlerReplyParams(2)
        let cases = params.cases||[]
        let is_renew_open = false

        cases.some((item,index)=>{
          if(item.quote_status==0&&index==0)
            is_first_reject = true
          if(item.is_renew_discount==1)
          {
            is_renew_open = true
            return true
          }

          return  false
        })
        if(!this.isFina)
          this.renew_discount_type = is_renew_open?2:1
        this.all_select = type==1?true:false
      }
      is_reject = this.getIsReject(params)
      if(this.isFina){
        if(is_reject){
          this.$refs['send-email-sms'].changeDialog()
        }
        else if(this.editType==3||this.referReplyType==1){
          this.onReplyAll()
        }
        else
          this.onComplete()
      }else
      {
        if(this.editType==3&&this.show_auto_reject){
          this.showAutoCloseSelectMessage = true
        }else
        {
          if(this.editType==3){
            this.showAutoSelectMessage = true
          }else {
            this.$refs['send-email-sms'].changeDialog()
          }
        }
      }
      // }
    },
    async onReplyAll() {
      const valid =await this.handler().validateForm()
      if(!valid) return

      const params =await this.handler().handlerReplyParams(2)
      this.network().replyReferral(params)
    },
    async onComplete() {
      const valid =await this.handler().validateForm()
      if(!valid) return

      const params =await this.handler().handlerReplyParams(3)
      this.network().replyReferral(params)
    },
    // 文件上傳成功
    handlerUploadSuccess({ data, result, otherData }) {
      const { target, index, fileIndex = '', name } = otherData
      if(target == 'documents') {
        if(fileIndex != '') {
          this.$set(this.quoteList[index].documents, fileIndex, data)
        }
        else {
          if(!this.quoteList[index].documents) {
            this.quoteList[index].documents = []
          }
          this.quoteList[index].documents.push(data)
        }
      }
      else if(target == 'renew_file_path_id'){
        this.quoteList[index][target] = data.id
        this.reject_fileData[index] = JSON.parse(JSON.stringify(data))
        this.refreshComponent(name)
      }
      else {
        this.quoteList[index][target] = data
      }
    },
    handlerDeleteFile(otherData) {
      const { fileIndex, index } = otherData
      this.quoteList[index].documents.splice(fileIndex, 1)
    },
    rejectDataHandleDel(otherData){
      if(this.editType == 3){
        const {index, target, name} = otherData.otherData
        this.$set(this.reject_fileData, index, {})
        this.refreshComponent(name)
        this.quoteList[index][target] = ''
      }
    },
    refreshComponent(name){
      this.$nextTick(() => {
        if(name){
          this.$refs[name][this.activeQuote].$forceUpdate()
        }else{
          this.$forceUpdate()
        }
      })
    },
    //主參數報價
    handlerReferralMain(index) {
      const params = {
        loading_pct: '',
        base_prm: '',
        cfd_pct: '',
        srd_pct: '',
        code_disc_pct: '',
        surcharge: '',
        mib_pct: '',
        ia_levy_pct: '',
        spec_disc_pct: '',
        spec_disc_prm: '',
        handling_fee: '',
        additional_charge: '',
        company_id: '',
        trm_of_cvr: '',
        basic_prm: '',
        mat_dam_prm: '',
        tppd_limit_prm: '',
        ec_levy_prm: '',
        ec_levy_pct: '',
      }
      Object.keys(params).some(key => {
        params[key] = this.quoteList[index][key]
      })
      params.refer_id = this.referId
      params.class_id = this.classId
      params.benefits = this.benefitList
      this.network().getReferralMain({
        params,
        index
      })
    },
    changePlan(type_list,index){
      this.plan_list[index] = type_list
    },
    changeCarPlan(){
      // this.type_list = this.coverTypeOptions
      // this.type_list = this.coverTypeOptions
      this.formDataLock += 1
    },
    getSubmitPremium(data, index, name){
      let {special_clause=[]} = data||{}
      if(name == 'benefit'){
        this.unSelectKeys = []
        this.benefitList = []
        Object.assign(this.benefitList, data.benefits)
        Object.assign(this.unSelectKeys, data.unSelectKeys)
      }
      Object.assign(this.quoteList[index]||{}, data)
      this.$forceUpdate()
    },
    getPlanCvrRemark(data){
      this.plan_cvr_remark = data
    },
    async changeExtraBenefits(data, index=0, origin){
      Object.assign(this.quoteList[index]||{}, data)
      if(origin && this.quoteList[index].company_id&&this.quoteList[index].plan_id){
        // 提前获取premium的数据，避免报loading缺失的错误
        let {company_id, plan_id, refer_id} = this.quoteList[index] || {}
        let params = {
          class_id: this.classId,
          company_id,
          plan_id,
          refer_id,
          order_id: this.renewOrderId
        }
        await this.$refs['premium'][index].network().getOrderPremiumData(params)
        this.selectExtraBenefit = JSON.parse(JSON.stringify(origin))
        this.$refs['premium'][index].handlerComputed()
        /*
        if(this.first){
          // 第一次触发的时候会因为拿不到extra的字段，所以会报没有loading字段的错误，要延迟触发
          setTimeout(() => {
            this.$refs['premium'][index].handlerComputed('reply')
            this.first = false
          },1000)
        }else{
          this.$refs['premium'][index].handlerComputed()
        }
        */
      }
    },
    getSubmitExcess(data, index,isCompute){
      let  params = {excess:data,...data}
      Object.assign(this.quoteList[index]||{}, params)
      if(isCompute)
        this.$refs['premium'][index].handlerComputed('reply')
    },
    submitPremium(form,data, index){
      this.subForm[form] = true
      Object.assign(this.quoteList[index]||{}, data)
    },
    getPremium(){
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      if (Object.values(this.subForm).some(item => item === false)) {

      }
    },
    handler() {
      return {
        validateForm: async () => {
          const productForm = {
            12: 'housemaid-reply-refer-form',
            13: 'working-reply-refer-form',
            14: 'travel-reply-refer-form',
            15: 'decoration-reply-refer-form',
            16: 'student-reply-refer-form',
            17: 'homefire-reply-refer-form',
            18: 'personal-reply-refer-form',
            20: 'fire-reply-refer-form',
            22: 'pet-reply-refer-form',
          }
          let is_reject = false
          // 表單校驗
          this.validateResult = []  // 初始化
          if(this.isSME) {
            let item = this.quoteList[0]
            this.validateResult[0] = false // 初始化標記
            let data = await this.$refs['sme-refer'][0].validateForm({index:0}).catch((err)=>{
              this.$message('請檢查是否有報價存在未填項')
              return false
            })
            if (data === false) {
              return false // 如果验证失败，直接返回
            }
            this.quoteList[0] = {...item,...data}
            return true
          }
          else{
            if(this.productId !== 11&&!this.isSME) {
              this.quoteList.forEach((item, index) => {
                this.validateResult[index] = false // 初始化標記
                if(item.quote_status)
                  is_reject = true
                this.$refs[productForm[this.productId]][index].validateForm({
                  index
                })
              })
            }
            else {
              this.quoteList.forEach((item, index) => {
                let subForm = item.quote_status? this.subForm : {}
                // if(item.trm_of_cvr!=2)
                //   delete subForm['benefit-form']
                if(item.quote_status)
                  is_reject = true
                Object.keys(subForm).some(key => {
                  this.subForm[key] = false
                  this.$refs[key][index].submitForm(key)
                })
                if (Object.values(subForm).some(item => item === false)) {
                  this.validateResult[index] = false
                  return
                }
                this.handler().validateMotorForm(index)
              })
            }
            if(this.validateResult.includes(false)&&is_reject||this.validateResult.includes(false)&&this.editType==3) {
              this.$message('請檢查是否有報價存在未填項')
              return false
            }
            return true
          }

        },
        validateMotorForm: async (index) => {
          // Object.keys(this.subForm).some(key => {
          //   this.subForm[key] = false
          //   this.$refs[key].submitForm(key)
          // })
          // if (Object.values(this.subForm).some(item => item === false)) {
          //   return
          // }
          await new Promise((resolve, reject) => {
            this.$refs['form'][index].validate((valid, rules) => {
              if(valid) {
                this.validateResult[index] = true
              }
              else {
                this.validateResult[index] = false
                this.scrollToValidDom(rules)
              }
            })
          })
        },
        // reply_type:
        // 1:  Save Draft
        // 2: Reply All to Client
        // 3: Complete Buyable Quote(s)

        handlerReplyParams: async (replyType) => {
          const quoteCase =await this.quoteList.reduce(async(result, item, index) => {
            let temp = JSON.parse(JSON.stringify(item)) // 深拷貝
            if(temp.extra_benefits_content && temp.extra_benefits_content.length){
              temp.extra_benefits_content.map(item => {
                let arr = []
                if(item.content.remark){
                  arr = item.content.remark.split('\n')
                }
                item.content.remark_arr = JSON.parse(JSON.stringify(arr))
              })
            }
            // motor
            if(this.productId == 11&&!this.isHzmb) {
              let excessParams =await this.$refs['excess-form'][index].submitForm()
              temp = Object.assign(temp, excessParams)
            }
            if(this.productId == 14)
              delete temp.underwriting
            if(this.isHzmb)
              temp.nm_drvr_cvr_ind = 1
            // temp.underwriting =null
            // 如果是 Home & Fire 需要處理一下 Excess 數據
            // product_id == 17
            // if(this.productId == 17) {
            //   // 解析 excess 數據
            //   temp.excess.some(excessItem => {
            //     excessItem.items.some(item => {
            //       if(item.field_1) {
            //         temp[item.field_1] = item.value_1
            //       }
            //       if(item.field_2) {
            //         temp[item.field_2] = item.value_2
            //       }
            //     })
            //   })
            // }
            // if(this.productId == 15) {
            //   console.log(temp)
            //   debugger
            // }
            temp.is_buyable_choose = 1
            // temp.is_buyable_choose = temp.is_buyable_choose || this.editType == 3? 1: 0
            result.push(temp)
            return result
          }, [])
          let send_obj = {
            is_send: this.renew_discount_type==2?0:this.isSend,
            is_send_renew_discount:this.renew_discount_type==1?0:this.isSend
          }
          if(this.editType==3){
            let {is_sms_send,content,email_content,share_content,is_share_send,is_email_send,is_referrer_send,referrer_content} = this.renew_send_data ||{}
            if(this.renew_discount_type==2)
            {
              send_obj = {
                // is_send_sms_renew_discount:this.renew_send_type==3?this.isSend:(this.renew_send_type==1?this.isSend:0),
                // is_send_email_renew_discount:this.renew_send_type==3?this.isSend:(this.renew_send_type==2?this.isSend:0),
                is_send_sms_renew_discount:is_sms_send||0,
                is_send_email_renew_discount:is_email_send||0,
                is_share_send:is_share_send||0,
                is_referrer_send:is_referrer_send||0,
                content,
                email_content,
                share_content,
                referrer_content
                // is_sms_send:0,
                // is_email_send:0
              }
            }else {
              send_obj = {
                // is_sms_send:this.renew_send_type==3?this.isSend:(this.renew_send_type==1?this.isSend:0),
                // is_email_send:this.renew_send_type==3?this.isSend:(this.renew_send_type==2?this.isSend:0),
                // is_send_sms_renew_discount:0,
                // is_send_email_renew_discount:0
                is_sms_send:is_sms_send||0,
                is_email_send:is_email_send||0,
                is_share_send:is_share_send||0,
                is_referrer_send:is_referrer_send||0,
                content,
                email_content,
                share_content,
                referrer_content
              }
            }
          }
          if((this.editType==3||[1,2].includes(this.referReplyType))&&this.isFina){
            send_obj.is_send  = 0
          }
          let data = {
            application: {
              ...this.ticketReferForm,
              less_verify_save: replyType === 3? 0: 1,
              content: this.smsContentResult,
              ...send_obj,
              ...this.auto_send
            },
            refer_id: this.referId,
            reply_type: replyType,
            cases: quoteCase,
          }
          if(this.editType==2&&!this.isFina){
            data.application.send_type = this.send_type
          }
          if(this.isSME)
          {
            data.application.order_id = this.form.order_id
            data.application.cust_typ = 2
          }
          // console.log(JSON.stringify(quoteCase))
          // console.log(JSON.stringify(data))
          return data
        },
        getPlanName: ({ company_id, class_id, plan_id ,plan}) => {
          // return this.getOptionName('plan', plan_id, this.globalOptions.plan)
          return plan
          // const key = `${company_id}${class_id}`
          // const options = this.globalOptions.plan[key]
          // return this.getOptionName(null, plan_id, options)
        },
        updateQuoteDetailData: async () => {
          if(this.isSME){
            await this.network().getNewSMEQuoteDetail({
            })
          }else
            await this.network().getQuoteDetail({
            // hideLoading: true
            })
        },
      }
    },
    setData(data){
      this.sendForm = data||this.form
      let is_discount = false
      let is_first_reject = false
      let is_other = false
      let discount_arr = ['code_disc_prm','coupon_vl','promo_disc_prm','spec_disc_prm','mib_disc_prm','ec_levy_disc_prm','ia_levy_disc_prm']
      if(this.isRenew){
        this.quoteList.forEach(( item, index) => {
          if(item.is_renew_discount==1){
            is_discount = true
          }else{
            discount_arr.some(key=>{
              if(item[key]>0)
                is_other = true
            })
          }
          if(item.quote_status==0&&index==0)
            is_first_reject = true
        })
      }
      if(data&&this.isRenew){
        const {share_user_infos,referrer,auto_renew_other_discount_reply_data,renew_other_discount_reply_data,share_renew_data,referrer_renew_data,auto_renew_close_data,renew_email_data={},renew_reply_data, renew_reply_list_title,renew_referrer_reply_data, renew_reply_title,renew_reply_reject_data,renew_discount_reply_data,auto_renew_reply_data,auto_renew_discount_reply_data} = data
        let has_referrer = false
        if(JSON.stringify(referrer) != '[]')
        {
          has_referrer =true
        }
        let renew_reply_send_data = is_discount?renew_discount_reply_data:is_other?renew_other_discount_reply_data:renew_reply_data
        let {share_renew_other_discount_reply_data,share_auto_renew_other_discount_reply_data,share_auto_renew_close_data,share_renew_reply_data,share_renew_discount_reply_data,share_auto_renew_discount_reply_data,share_auto_renew_reply_data} =share_renew_data||{}
        let share_content = is_discount?share_renew_discount_reply_data:(is_other?share_renew_other_discount_reply_data:share_renew_reply_data)
        let refer_content = is_discount?referrer_renew_data.share_renew_discount_reply_data:(is_other?referrer_renew_data.share_renew_other_discount_reply_data:referrer_renew_data.share_renew_reply_data)

        let email_content =  is_discount?renew_email_data.renew_discount_reply_data:(is_other?renew_email_data.renew_other_discount_reply_data:renew_email_data.renew_reply_data)
        this.auto_renew_close_data = auto_renew_close_data
        this.share_auto_renew_close_data = share_auto_renew_close_data
        this.email_auto_renew_close_data = renew_email_data.auto_renew_close_data
        if (this.auto_on){
          renew_reply_send_data = is_discount?auto_renew_discount_reply_data:(is_other?auto_renew_other_discount_reply_data:auto_renew_reply_data)
          email_content = is_discount?renew_email_data.auto_renew_discount_reply_data:(is_other?renew_email_data.auto_renew_other_discount_reply_data:renew_email_data.auto_renew_reply_data)
          share_content = is_discount?share_auto_renew_discount_reply_data:(is_other?share_auto_renew_other_discount_reply_data:share_auto_renew_reply_data)
          refer_content = is_discount?referrer_renew_data.share_auto_renew_discount_reply_data:(is_other?referrer_renew_data.share_auto_renew_other_discount_reply_data:referrer_renew_data.share_auto_renew_reply_data)
        }
        this.reply_content =''
        this.init_share_content =''
        this.init_email_content =''
        this.init_refer_content =''
        this.reply_content =  this.editType==3&&this.isFina?renew_referrer_reply_data:renew_reply_send_data
        this.reject_content = renew_reply_reject_data
        this.init_share_content = share_content
        this.init_refer_content = refer_content
        this.init_email_content = email_content
        this.list_title = renew_reply_list_title
        this.eamil_title = renew_reply_title
      }
    },
    network() {
      return {
        getReferralMain: async ({ params, index }) => {
          const { data } = await getReferralMain(params)
          this.quoteList[index] = Object.assign(this.quoteList[index], data)
          // this.formData = Object.assign(this.formData, data)
        },
        getReferralQuoteDel: async ({ params, index }) => {
          if(this.editType == 3){
            params.order_id = this.renewOrderId
            var {data} = await renewQuoteDel(params)
          }else{
            var { data } = await getReferralQuoteDel(params)
          }
          this.quoteList.splice(index,1)
          setTimeout(()=>{
            this.activeQuote = 0
          },50)
          // this.formData = Object.assign(this.formData, data)
        },
        // reply_type:
        // 1:  Save Draft
        // 2: Reply All to Client
        // 3: Complete Buyable Quote(s)
        replyReferral: async params => {
          if(this.editType == 3){
            params.order_id = this.renewOrderId
            var { data } = await renewReply(params)
            // await this.handler().updateQuoteDetailData()
            // this.$refs['send-email-sms'].changeDialog()
          }else{
            var { data } = await replyReferral(params)
          }
          const { reply_type } = params
          const emitEvent = [
            'save-draft',
            'reply-all',
            'complete'
          ]
          let is_reject = this.getIsReject(params)

          let {sme_versions} = this.$route.query||{}
          if(is_reject&&this.isFina){
            let send_params = {
              order_id:this.editType == 3? this.renewOrderId :this.form.order_id,
              content:this.smsContentResult
            }
            await this.mixinNetwork().sendQuoteReferrer(send_params)
          }
          if((this.editType == 3||this.referReplyType!=0)&&this.isFina&&!is_reject){
            this.$router.push({
              path: '/quoting/referrer/send/payment',
              query: {
                order_id: this.editType == 3?this.renewOrderId:this.form.order_id,
                product_id: this.productId,
                sme_versions,
              }
            })
          }else
            this.$emit(emitEvent[reply_type-1])
        },
        renewReplySend: async () => {
          const {data} = await renewReplySend({
            order_id: this.renewOrderId,
            content: this.smsContentResult
          })
          const {code} = data
          if(code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.$emit('reply-all')
          }
        },
        changeReferralStts: async params => {
          // reply_type 參數説明：
          // 1： Reply All to Client  向客戶第一次發出報價
          // 2： With Draw Quote  退回第一次發出報價
          // 3:  Complete Buyable Quote(s)  向客戶第二次發出可購買報價
          // 4： Download to Price Quote  退回第二次發出報價
          const { data } = await changeReferralStts({
            refer_id: this.referId,
            ...params
          })
          if(params.reply_type === 1) {
            this.$emit('reply-all')
          } else {
            this.$emit('complete')
          }
        },
        sendReferralSms: async content => {
          const { data } = await sendReferralSms({
            order_id: this.form.order_id,
            content
          })
          this.$refs['send-email-sms'].changeDialog()

          if(this.referReplyType == 1) {
            this.onReplyAll()
          }
          else {
            this.onComplete()
          }
        },

        // quote detail
        getQuoteDetail: async (params) => {
          const {data} = await getQuoteDetail({
            order_id: this.editType == 3? this.renewOrderId : this.form.order_id,
            ...params
          },this.productId)
          this.detailData = data
          this.setData(data)
        },
        getNewSMEQuoteDetail: async (params) => {
          const {data} = await getNewSMEQuoteDetail({
            order_id: this.editType == 3? this.renewOrderId : this.form.order_id,
            ...params
          })
          this.detailData = data
          this.setData(data)
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.reply-refer {
    position: relative;
    // padding: 15px 15px 100px 15px;
    .abs-top-right {
        top: 5px;
        right: 15px;
    }
    .star {
        display: block;
        margin-right: 7px;
        width: 18px;
        height: 18px;
        background: #F7B500;
        clip-path: polygon(9px 0, 12px 6px, 18px 6px, 14px 12px, 16px 18px, 9px 14px, 2px 18px, 4px 12px, 0px 6px, 6px 6px);
      }
    .main-left {
        margin-right: 20px;
        min-width: 250px;
        max-width: 300px;
        ul {
            margin-bottom: 20px;
            li {
                display: flex;
                align-items: center;
                padding: 10px 20px;
                // height: 50px;
                // line-height: 50px;
                color: #409eff;
                font-size: 16px;
                list-style: none;
                word-break: break-word;
                cursor: pointer;
                &.active {
                    background: #D9ECFF;
                    border-radius: 4px;
                }
                .el-checkbox {
                  margin-right: 10px;
                }
                .star {
                  margin-right: 10px;
                }
            }
        }
    }
    .star-remark {
      display: flex;
      align-items: center;;
      margin-bottom: 15px;
      padding: 10px 15px;
      color: #91939A;
      background: #E9E9EB;
      .star {
        display: block;
        margin-right: 7px;
        width: 18px;
        height: 18px;
        background: #F7B500;
        clip-path: polygon(9px 0, 12px 6px, 18px 6px, 14px 12px, 16px 18px, 9px 14px, 2px 18px, 4px 12px, 0px 6px, 6px 6px);
      }
    }
    .flex-excess {
      display: flex;
      align-items: center;
      & > .el-checkbox {
        margin: 0 15px;
      }
      & > span {
        display: inline-block;
        padding: 0 15px;
      }
    }
    .form-excess-half {
      width: 500px;
    }
  .extra_box{
    ::v-deep .el-checkbox-group {
      .el-checkbox{
        padding: 20px  20px 0  20px;
        background: #FFFFFF;
        border: 1px solid #D1D5DA;
        box-sizing: border-box;
        border-radius: 6px;
        width: 50%;
        margin-bottom: 20px;
      }
    }
    .extra-name{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.15px;
      color: #24292E;
      margin-bottom: 20px;
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
  }
  .special-text{
    display: flex;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.15px;
    color: #d73a49;
    .flex-1{
      flex: 1;
    }
    .flex-2{
      flex: 42;
    }
    /*margin-bottom: 20px;*/
  }
}
.del_line{
  text-decoration: line-through
}
</style>
